import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/account.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate
{
  /**
   * Constructor
   */
  constructor(
      private _authService: AuthService,
      private _router: Router
  )
  {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Can activate
   *
   * @param route
   * @param state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
  {
    

    let isUserLogin = false;


    
    var user = JSON.parse(localStorage.getItem('user'));
    if(user && user != null && user !='undefined')
    {
      isUserLogin = true;
    }


    this._authService.getCurrentUser$.subscribe(user=>{
      if(user)
      {
        isUserLogin = true;
      }
    });
    
    if(!isUserLogin)
    {
      this._router.navigate(['/pages/login'],{queryParams:{'redirectURL':state.url}});
      return false;
    }
      return isUserLogin;
  }


  

  

  
}
